import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { ArrkPreset } from '@arrk-nx/shared-styles';
import { appRoutes } from './app.routes';
import {
  CMS_API_BASE_URL,
  CMS_BYPASS_GUARD,
  CMS_COGNITO_CLIENT_IDS,
  CMS_PLATFORM_ORIGINS,
  CMS_DEV_TOKEN,
  cmsAuthInterceptor
} from '@arrk-nx/arrk-cms-libs';
import { environment } from '../environments/environment';
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([cmsAuthInterceptor])),
    provideAnimations(),
    providePrimeNG({
      ripple: false,
      theme: {
        preset: ArrkPreset,
        options: {
          darkModeSelector: '[data-theme$="-dark"]',
          cssLayer: {
            name: 'primeng',
            order: 'primeng'
          }
        }
      }
    }),
    { provide: CMS_PLATFORM_ORIGINS, useValue: environment.platformOrigins },
    { provide: CMS_COGNITO_CLIENT_IDS, useValue: environment.cognitoClientIds },
    { provide: CMS_BYPASS_GUARD, useValue: environment.bypassGuard },
    { provide: CMS_API_BASE_URL, useValue: environment.cmsApiBaseUrl },
    { provide: CMS_DEV_TOKEN, useValue: environment.cmsDevToken }
  ]
};
